module.exports = function() {
    return function({ e, addVariant }) {
        addVariant('oprema', ({ modifySelectors, separator, container }) => {
            modifySelectors(({ className }) => {
                return `body[data-theme="oprema"] .${e(`oprema${separator}${className}`)}`;
            });
        });
    };
};
